import axios from 'axios';

import { SUBMIT_PATIENT_FORM, VITE_PARTNER_URL } from 'constants/env.js';

export const createCallAPI = async ({ token, ...payload }) => {
    const response = await axios.post(SUBMIT_PATIENT_FORM, payload, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });

    return response.data;
};

export const getCallAPI = async ({ accessToken, partnerId, callId }) => {
    return axios.get(`${VITE_PARTNER_URL}${partnerId}/calls/${callId}`, {
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
    });
};
